export default __webpack_public_path__ + "static/static-2eeab36d083731d3900a7d99ded3e078.mp4";